export default IconCurrencyKip => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-kip" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 12h12" />
  <path d="M9 5v14" />
  <path d="M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7" />
</svg>`;